import React from 'react';
import Footer from '../components/Footer.jsx';
import SeoHead from '../components/seo/SeoHead.jsx';
import SiteNav from '../components/seo/SiteNav.jsx';

const StandardSection = ({section}) => (
  <section
    id={section.id}
    className="scroll-mt-6 rounded-2xl border border-white/10 bg-white/[0.04] p-5"
  >
    <h2 className="text-xl font-black text-white">{section.heading}</h2>
    <p className="mt-3 leading-7 text-white/65">{section.body}</p>

    {section.items && (
      <ul className="mt-4 space-y-2">
        {section.items.map(item => (
          <li key={item} className="flex gap-2 text-sm leading-6 text-white/60">
            <span aria-hidden="true" className="text-emerald-400">✓</span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    )}

    {section.links && (
      <div className="mt-4 flex flex-wrap gap-2">
        {section.links.map(link => (
          <a
            key={link.href}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            className="rounded-xl border border-indigo-400/30 bg-indigo-500/10 px-4 py-2 text-sm font-black text-indigo-200 hover:bg-indigo-500/20"
          >
            {link.label}
          </a>
        ))}
      </div>
    )}
  </section>
);

const FaqSection = ({faqs}) => (
  <section aria-labelledby="faq-list-heading" className="space-y-3">
    <h2 id="faq-list-heading" className="sr-only">問題與答案</h2>
    {faqs.map((item, index) => (
      <article
        key={item.question}
        className="rounded-2xl border border-white/10 bg-white/[0.04] p-5"
      >
        <h2 className="text-lg font-black text-white">
          {index + 1}. {item.question}
        </h2>
        <p className="mt-3 leading-7 text-white/65">{item.answer}</p>
      </article>
    ))}
  </section>
);

const ContentPage = ({page}) => (
  <div className="content-page min-h-[100dvh] bg-[#020617] text-white">
    <SeoHead page={page} />

    <div className="fixed inset-0 pointer-events-none" aria-hidden="true">
      <div className="blob blob-a" />
      <div className="blob blob-b" />
      <div className="grid-bg" />
    </div>

    <header className="relative z-10 border-b border-white/10 bg-slate-950/80 backdrop-blur-xl">
      <div className="mx-auto flex w-full max-w-4xl flex-col gap-4 px-4 py-4 sm:flex-row sm:items-center sm:justify-between">
        <a href="/" className="flex items-center gap-2 font-black text-white">
          <span aria-hidden="true">🏸</span>
          羽球計分板
        </a>
        <SiteNav compact />
      </div>
    </header>

    <main className="relative z-10 mx-auto w-full max-w-3xl px-4 py-10">
      <article>
        <header className="mb-8">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.25em] text-indigo-300">
            Badminton Scorer
          </p>
          <h1 className="text-3xl font-black leading-tight text-white sm:text-4xl">
            {page.h1}
          </h1>
          <p className="mt-4 text-base leading-7 text-white/65">
            {page.intro}
          </p>
        </header>

        {page.type === 'faq' ? (
          <FaqSection faqs={page.faqs} />
        ) : (
          <div className="space-y-4">
            {page.sections.map(section => (
              <StandardSection key={section.id} section={section} />
            ))}
          </div>
        )}

        <aside className="mt-8 rounded-2xl border border-emerald-500/25 bg-emerald-500/10 p-5">
          <h2 className="text-lg font-black text-emerald-200">
            想立即開始計分？
          </h2>
          <p className="mt-2 text-sm leading-6 text-white/60">
            返回首頁設定單打或雙打比賽，所有比分和設定都在目前瀏覽器處理。
          </p>
          <a
            href="/"
            className="mt-4 inline-flex rounded-xl bg-white px-4 py-2.5 text-sm font-black text-slate-900 transition hover:bg-emerald-300"
          >
            開啟羽球計分板
          </a>
        </aside>
      </article>
    </main>

    <Footer hideButton centered />
  </div>
);

export default ContentPage;